import { msToast } from 'msComponents';

// 这里在组件库ts化且暴露type之后会废弃
interface IToast {
  loading: any;
  clear: () => void;
}

let toast: IToast | null = null;

// 请求次数
let requestTimes = 0;

// 开始loading
const startLoading = (title?: string) => {
  requestTimes++;
  if (!toast) {
    toast = msToast.loading({
      message: title ?? '加载中···',
      duration: 0,
    });
  }
};

// 结束loading
const clearLoading = () => {
  // 如果小于等于一个请求：清零
  if (requestTimes <= 1) {
    requestTimes = 0;
    toast?.clear();
    toast = null;
  } else {
    // 每次请求数-1
    requestTimes--;
  }
};

// 这么写是方便拓展
// 例如：requestTimes 非 0的时候全局loading
const loading = {
  start: (title?: string) => startLoading(title),
  destory: () => clearLoading(),
};

export default loading;
